import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/kalender-hijriah/")({
  beforeLoad: () => {
    throw redirect({ to: "/en/hijri-calendar" } as any as any);
  },
  component: () => null,
});
